const e = {
  name: "Warning",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22.7,0h-5.4l-4.3,13h0L6.3,33H0v7h40v-7h-6.3l-6.7-20h0L22.7,0z M28.6,24l3,9H8.4l3-9H28.6z M27.9,22H12.1
			l3-9h9.9L27.9,22z M2,35h36v3H2V35z M24.3,11h-8.6l3-9h2.6L24.3,11z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Warning
};
